import { Grid } from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  getLocalValue,
  IRoleMain,
  LoacalVariables,
  MasterPages
} from "../../commonFunctions/CommonFunctions";
import { getPermissions } from "../../commonFunctions/PermissionManger";
import WSDataGrid, { IColumns } from "../../Components/DataGrid/WSDataGrid";
import { HeaderList } from "../../Components/Header/HeaderList";
import PermissionDenied from "../../commonFunctions/PermissionDenied";
import { resetDataComponent } from "../../StateManagement/actions";
import { useDispatch } from "react-redux";
import { useSnackbar } from "../../Components/Snackbar/SnackBarContext";
import ConfirmationPopup from "../../Components/Confirmation/Confirmation";
import { WSIcons } from "../../commonFunctions/iIcons";

export const ProductList: React.FC<any> = React.memo((props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { showMessage } = useSnackbar();
  const { edit, add, view, exports } = getPermissions(
    MasterPages.Product,
    IRoleMain.Masters
  );

  const [totalCount, setTotalCount] = useState<any>();
  const [selectedId, setSelectedId] = useState<any>(null);
  const [isPopupOpen, setPopupOpen] = useState(false);

  const source = {
    url: "laundry-products/search",
    page: 1,
    pageSize: 10,
    filter: [],
    sort: []
  };

  /**
   *  Edit function
   * @param action
   * @param row
   */
  const handleAction = async (action: string, row: any) => {
    if (action === "Edit") {
      navigate(`/product/${row?.productId}`);
    } else if (action === "Delete") {
      setSelectedId(row?.productId);
      setPopupOpen(true);
    }
  };

  const handleDelete = (response: any) => {
    dispatch(resetDataComponent("productGrid"));
    showMessage("Product deleted successfully!", "success");
  };

  const columns: IColumns[] = [
    {
      header: "image",
      fieldName: "imageUrl",
      type: "img"
    },
    {
      header: "name",
      fieldName: "productName",
      tooltip: true
    },

    {
      header: "Created Date",
      fieldName: "createdDate",
      tooltip: true,
      type: "date"
    },
    {
      header: "Updated Date",
      fieldName: "updatedDate",
      tooltip: true,
      type: "date"
    },
    {
      header: "Actions",
      fieldName: "actions",
      type: "action",
      icon: true,
      actions: [edit ? "Edit" : undefined, "Delete"],
      actionIcons: {
        Edit: <WSIcons.Edit color="primary" />,
        Delete: <WSIcons.Delete color="error" />
      },
      actionCallback: (action, row) => handleAction(action, row)
    }
  ];

  const handleClick = () => {
    navigate("/product");
  };
  const transFormData = (data: any, totalCount: any) => {
    setTotalCount(totalCount);
    return data;
  };
  return (
    <>
      <HeaderList
        title="Products"
        type="card"
        info={`${totalCount || 0} Total Records`}
      />
      {view ? (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <WSDataGrid
              id="productGrid"
              title="Products"
              columns={columns}
              source={source}
              exportCsv={exports}
              addButton={add ? { label: "", color: "secondary" } : undefined}
              onAddButtonClick={handleClick}
              transFormData={transFormData}
              headerType="HaderTopCornered"
            />
          </Grid>
        </Grid>
      ) : (
        <PermissionDenied />
      )}

      {selectedId !== null && (
        <ConfirmationPopup
          apiUrl={"laundry-products"}
          id={selectedId}
          confirmMessage="Are you sure you want to delete this product?"
          open={isPopupOpen}
          onClose={() => setPopupOpen(false)}
          onConfirm={handleDelete}
          permanent
        />
      )}
    </>
  );
});
